import { BsCheckCircle } from 'react-icons/bs';
import { ImWhatsapp } from 'react-icons/im';
import { FaFacebookF } from 'react-icons/fa';
import { FaTwitter } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { FaDiscord } from 'react-icons/fa';
import './banner.css';
import UserAppContext from '../../hook/UserAppContext';

const Banner = () => {

      const {user, dataApp} = UserAppContext()

      const {infordata, banners, social} = user.user
      const WHATSAPP = "(xx) xxxx-xxxx"

      return (
            <div className="header_content">
                  <div className="header_banner">
                        <img src={banners.data ? dataApp.banner.image : banners[0].image} alt={banners.data ? dataApp.banner.title : banners[0].title} />
                  </div>
                  <div className="container header">
                        <div className="header_col left">
                              <h1>{banners.data ? dataApp.banner.title : banners[0].title}</h1>
                              <p>
                                    {infordata.data || infordata.about === '' ? dataApp.info.about : infordata.about}
                              </p>
                              <a href={infordata.data || infordata.xat_room === '' ? dataApp.info.xat_room : infordata.xat_room} target="_blank" rel="noreferrer">My xat</a>
                        </div>
                        <div className="header_col right">
                              <div className="header_user">
                                    <div className="user_avatar">
                                          <img src={infordata.data || infordata.avatar === '' ? dataApp.info.avatar : infordata.avatar} alt={infordata.data || infordata.name === '' ? dataApp.info.name : infordata.name} />
                                    </div>
                                    <strong>{infordata.data || infordata.name === '' ? dataApp.info.name : infordata.name}</strong>
                                    <div className="user_details">
                                          <BsCheckCircle />
                                          <span>{infordata.data || infordata.status === '' ? dataApp.info.status : infordata.status}</span>
                                    </div>
                                    <div className="user_details">
                                          <ImWhatsapp />
                                          <span>{WHATSAPP}</span>
                                    </div>
                                    <div className="user_social">
                                          <a href={social.data || social.facebook === '' ? 'https://www.facebok.com' : social.facebook} target="_blank" rel="noreferrer"><FaFacebookF /></a>
                                          <a href={social.data || social.twitter === '' ? 'https://www.twitter.com' : social.twitter} target="_blank" rel="noreferrer"><FaTwitter /></a>
                                          <a href={social.data || social.instagram === '' ? 'https://www.instagram.com' : social.instagram} target="_blank" rel="noreferrer"><FaInstagram /></a>
                                          <a href={social.data || social.discord === '' ? 'https://www.discord.com' : social.discord} target="_blank" rel="noreferrer"><FaDiscord /></a>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default Banner;